module.exports = __webpack_public_path__ + "img/stuck_out_tongue_closed_eyes.cb0ad6bd.gif";